export const tS3FIleIORoute = '';
export const GET_FILE_UPLOAED_STATUS = (uuid: string) => {
  let route = '';
  if (uuid) {
    route += `/${uuid}`;
  }
  return `/api/s3/files${route}`;
}
